// extracted by mini-css-extract-plugin
export default {"rating":"vI-z","numberOfStars":"wI-z","count":"xI-z","barGraphSpacing":"yI-z","barGraph":"zI-z"};